module.exports = __webpack_public_path__ + "bcfd2b04f49e4a142955fc70c05860e2.glb";